import StoreCouponsPage from 'components/pages/Store';

import placeholder from 'lib/placeholder';
import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getCouponsList } from 'services/coupon';
import { getLandingsList } from 'services/landing';
import {
  getPopularStoresListWithOffersCount,
  getStoresList,
} from 'services/store';

import APP from 'constants/app';
import COUPONS from 'constants/coupons';
import LINKS from 'constants/links';
import SOCIAL_MEDIA from 'constants/socialMedia';
import { SORT_VALUES } from 'constants/sort';
import STORES from 'constants/store';

const PROMOBIT_STORE_PROPS = {
  gaEventCategory: 'promobit_coupons',
  isExclusivelyCoupon: true,
  isStoreChecklistActive: false,
  store: {
    couponsMetaTitle: placeholder('seo.promobitCoupons.title'),
    couponsMetaDescription: placeholder('seo.promobitCoupons.description'),
    isStoreVerified: true,
    storeId: 629,
    storeName: 'Promobit',
    storeDomain: APP.SHORTENED_URL,
    storeSlug: 'promobit',
    storeImage: `${APP.LOCAL_IMAGE_PATH}/general/logos/promobit-logo-icon.svg`,
    storeFacebookPage: SOCIAL_MEDIA.FACEBOOK.URL,
    storeDescription:
      'O Promobit é a maior comunidade de ofertas da internet com 2 milhões de usuários que economizam em suas compras online, aproveitando mais de 700 ofertas diárias publicadas na plataforma, além de cupons de desconto, inclusive com cupom exclusivo e dicas sobre consumo, seja pelo site ou aplicativo.',
    couponPageDescription: [
      {
        title: 'Cupom exclusivo Promobit no site e no APP',
        paragraphs: [
          'Muitas vezes o preço de algum produto que queremos comprar está apenas um pouco acima do valor que nos programamos para gastar e são nestes momentos em que o <a href="/cupons/"> cupom de desconto</a> pode fazer toda a diferença, sendo o detalhe que faltava para que o produto que pretende comprar caiba no seu orçamento ou, simplesmente, por deixar ainda mais baixo um preço que já pode estar barato.',
          'Aqui no Promobit você encontra os melhores cupons de desconto da internet, inclusive cupom exclusivo que só pode ser encontrado em nossa comunidade e que garante bons descontos em seu carrinho de compras. Com algum cupom no App ou no site do Promobit é possível obter uma diminuição considerável no valor de muitos produtos, seja para compras corriqueiras, cupom de primeira compra e cupom com frete grátis.',
          'Em nossa página de cupons exclusivos você encontra vouchers que possibilitam economizar nos principais e-commerces, como com o <a href="/cupons/loja/americanas/">cupom Americanas</a>, <a href="/cupons/loja/casas-bahia/">cupom Casas Bahia</a>, <a href="/cupons/loja/submarino/">cupom Submarino</a> ou <a href="/cupons/loja/netshoes/">cupom Netshoes</a>.',
          'O Promobit é uma rede social especializada em promoções e com as melhores ofertas da internet, já que, em média, mais de 700 ofertas são compartilhadas por dia pelos próprios usuários e, após serem verificadas por uma equipe de especialistas em promoções, são publicadas na plataforma.',
        ],
      },
      {
        title: 'Como usar o cupom exclusivo do Promobit?',
        paragraphs: [
          'A melhor forma de não perder nenhum cupom exclusivo do Promobit é ficar atento se o cupom está ativo, pois cupons de desconto possuem prazo de validade específico. Outro aspecto é que alguns cupons só oferecem desconto em compras a partir de um determinado valor pré-estabelecido. Na dúvida, confira as regras de cada cupom antes de saber os detalhes.',
          'Com cupom de desconto você pode economizar ainda mais na compra de produtos de diversas categorias. Seja com <a href="/promocoes/smartphones-tablets-e-telefones/">cupom para celular</a>, ou na hora de comprar calçados com <a href="/promocoes/calcados-masculinos/s/">cupom de tênis</a>.',
          'Para não perder a oportunidade de fazer a melhor compra, é bom ficar atento a alguns pontos. Primeiro, na hora de selecionar o seu cupom, para garantir o desconto, observe se o mesmo ainda está ativo, pois os códigos podem possuir validade. A data poderá ser encontrada nas regras de utilização, bem como outras informações. Outros só garantem o desconto acima de um determinado valor de compra, por isso é importante estar atento às condições da promoção.',
        ],
      },
      {
        title:
          'Cupons exclusivos e as melhores ofertas da internet estão aqui no Promobit.',
        paragraphs: [
          'Além de cupons exclusivos e os melhores cupons de desconto, aqui no Promobit você também encontra as melhores ofertas da internet e com preço baixo de verdade, já que todas as ofertas publicadas pelos usuários do Promobit passam por um criterioso processo de avaliação que garante o preço realmente baixo e de lojas confiáveis. Baixe o App do Promobit e confira as melhores promoções.',
        ],
      },
    ],
  },
};

const PromobitCoupons = (props) => (
  <StoreCouponsPage {...props} {...PROMOBIT_STORE_PROPS} />
);

export const getServerSideProps = async ({ query }) => {
  try {
    const [
      serverCoupons,
      popularStores,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getCouponsList({
        limit: COUPONS.COUPONS_LIMIT,
        sort: SORT_VALUES.LATEST,
        couponCodeFilter: COUPONS.PROMOBIT_COUPON_CODE,
        /**
         * Forces initial page to avoid possible different request results
         * between server and client
         */
        after: 1,
        ...query,
      }),
      {
        fn: getPopularStoresListWithOffersCount({
          limit: STORES.POPULAR_STORES_LIMIT,
        }),
        fallback: getPopularStoresListWithOffersCount.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        popularStores: popularStores || [],
        serverCoupons,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default PromobitCoupons;
